import React from 'react'
import DefaultLayout from '../DefaultLayout'

const Directory = props => {
  return (
    <DefaultLayout {...props}>
      <h1>Welcome to the collection of UI components!</h1>
      <p>
        You can supply a new page for this start screen for this by supplying
        different options to @kogk/gatsby-plugin-ui-lib
      </p>
    </DefaultLayout>
  )
}

export default Directory
